module.exports = __webpack_public_path__ + "media/dorobek/assets/images/authors-b79e8d6ce95a11ffbf792d300b8c5ef4.svg";